import { useAuthUserPureUpdateMutation, UserPureUpdateMutationInput } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { UserDataType } from './types';

const useUserUpdate = (onComplete?: (data?: UserDataType) => void) => {
  const [mutation, mutationResult] = useAuthUserPureUpdateMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
    onCompleted: (data) => {
      onComplete?.(data.userPureUpdate?.user as UserDataType);
    },
  });

  const request = async (input: UserPureUpdateMutationInput) => {
    const mutationResult = await mutation({
      variables: {
        input,
      },
    });

    return {
      ok: !!mutationResult.data?.userPureUpdate?.ok,
      user: mutationResult.data?.userPureUpdate?.user as UserDataType,
    };
  };

  return {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    data: {
      user: mutationResult.data?.userPureUpdate?.user,
    },
    request,
  };
};

export default useUserUpdate;
